import * as React from 'react';
import axios from "axios";
import { useTranslation } from 'react-i18next';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import clsx from 'clsx';

interface IProps {
	value: string,
    onChange: (value: string) => void,
    dictionaryType: string,
    className?: string,
    freeSolo?: boolean,

    errorText?: string,
    isDemo: boolean,
    isLogSystemIntegrationAvailable: boolean,
}

export default function LogDictionaryAutocomplete(props: IProps) {
    const { t } = useTranslation();
    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState<string[]>([]);
    const loading = open && options.length === 0 && props.isLogSystemIntegrationAvailable && !props.isDemo;
    
    React.useEffect(() => {

        if (!props.isLogSystemIntegrationAvailable || props.isDemo) {
            return;
        }
        if (!loading) {
            return;
        }

        let active = true;
        (async () => {
            const response = await loadData();

            if (active) {
                setOptions(response.data);
            }
        })();

        return () => {
            active = false;
        };
    }, [loading]);


	async function loadData() {
		
        const data = await axios.get<string[]>("/Issues/GetLogDictionaryAutocomplete/", {
			params: {
                maxRows: 1500,
                dictionary: props.dictionaryType
			},
        });

        return data;
	}

    let noOptionsMessage = t("control.autocomplete.noOptionsMessage");
    if (!props.isLogSystemIntegrationAvailable) {
        noOptionsMessage = t("common.message.logSystemIntegrationDisabled");
    }
    if (props.isDemo) {
        noOptionsMessage = t("common.message.liveDemoInfo");
    }

    return (<Autocomplete
        className={clsx("mi-lab-autocomplete-outlined", "qd-combocoxs-control", props.className)}

        value={props.value}
        onChange={(event, newValue) => {
            props.onChange(newValue ?? "");
        }}
        freeSolo={props.freeSolo}
        open={open}
        onOpen={() => {
            setOpen(true);
        }}
        onClose={() => {
            setOpen(false);
        }}
        options={options}
        loading={loading}
           
        clearText={t("common.action.clear")}
        noOptionsText={noOptionsMessage}
        openText={t("common.action.open")}
        closeText={t("common.action.close")}
        loadingText={t("common.loading") + "..."}
        getOptionSelected={(option, value) => option == value}

        renderInput={params => (
            <TextField
                {...params}
                variant="outlined"
                error={!!props.errorText}
                helperText={props.errorText}
                fullWidth
                onChange={(event) => {
                    if (props.freeSolo) {
                        props.onChange(event.target.value);
                    }
                }}
                InputProps={{
                    ...params.InputProps,
                    autoComplete: 'disabled',
                    endAdornment: (
                        <React.Fragment>
                            {loading  ? <CircularProgress color="inherit" size={20} /> : null}
                            {params.InputProps.endAdornment}
                        </React.Fragment>
                    ),
                }}
            />
        )}
    />);
}
